'use strict';

var _merge = require('merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

module.exports = function (h, that) {

  if (!that.opts.filterByColumn || !that.opts.filterable) return '';

  var textFilter = require('./text-filter')(h, that);
  var dateFilter = require('./date-filter')(h, that);
  var listFilter = require('./list-filter')(h, that);
  var multiFilter = require('./multi-filter')(h, that);

  var filters = [];
  var filter;
  var colIndex = -1;

  if (that.hasChildRow && that.opts.childRowTogglerFirst) filters.push(h('th'));

  that.allColumns.map(function (column) {

    var filter = '';
    colIndex += 1;

    if (that.filterable(column)) {
      switch (true) {
        case that.isMultiFilter(column):
          filter = multiFilter(column);break;
        case that.isTextFilter(column):
          filter = textFilter(column);break;
        case that.isDateFilter(column):
          filter = dateFilter(column);break;
        case that.isListFilter(column):
          filter = listFilter(column);break;
      }
    }

    if (typeof that.$slots['filter__' + column] !== 'undefined') {
      filter = filter ? h('div', [filter, that.$slots['filter__' + column]]) : that.$slots['filter__' + column];
    }

    filters.push(h(
      'th',
      { 'class': that.columnClass(column), ref: 'FC' + colIndex },
      [h(
        'div',
        _defineProperty({ 'class': 'VueTables__column-filter' }, 'class', 'VueTables__' + column + '-filter-wrapper'),
        [filter]
      )]
    ));
  });

  if (that.hasChildRow && !that.opts.childRowTogglerFirst) filters.push(h('th'));

  return h(
    'tr',
    { 'class': 'VueTables__filters-row' },
    [filters]
  );
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/template/column-filters.js